/*
 * WW Dotnav — timed-fill + viewport gate driver for the .ww-dotnav--timed capsule pagination
 * Version: 1.2.0 - 2026-08-20 20:05 (UTC+8) - Plaud Tayler — i18n: pause/resume aria-labels read from data-label-pause / data-label-play (locale keys) instead of JS literals
 * Version-note: 1.1.0 - 2026-08-13 10:20 (UTC+8) - Plaud Tayler — WCAG 2.2.2 pause/resume control ([data-dotnav-pause] in the capsule wrap): user pause outranks the viewport gate; reduced-motion boots into the paused state (explicit opt-in to restart)
 * Version-note: 1.0.0 - 2026-08-11 13:10 (UTC+8) - Plaud Tayler — DTC-1023 iteration: Apple-style timed
 *   dot fill. Swiper autoplay owns the clock; this bridge writes its autoplayTimeLeft progress into
 *   the --ww-dot-progress CSS var (fill = scaleX), so hover-pause freezes the bar with zero drift.
 *   An IntersectionObserver stops/starts autoplay outside the viewport (Apple "activated" behavior).
 * Document-level IIFE, guarded; binds each slide-section once (MutationObserver until swiper init).
 */
(function () {
  if (window.__wwDotnav) return;
  window.__wwDotnav = true;

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      var sw = en.target.globalSlide;
      if (!sw || sw.destroyed || !sw.params.autoplay || !sw.params.autoplay.delay) return;
      if (en.isIntersecting) {
        /* an explicit user pause (WCAG 2.2.2 control) outranks the viewport gate */
        if (!en.target.__wwDotnavUserPaused) sw.autoplay.start();
      } else {
        sw.autoplay.stop();
      }
    });
  }, { threshold: 0.3 });

  /* pause/resume control (WCAG 2.2.2): document-delegated, one per timed capsule
     - Plaud Tayler - 2026-08-13 10:20 - Begin */
  function setPauseState(btn, paused) {
    /* labels arrive from Liquid data-* (locale keys); a JS literal is untranslatable and
       stayed English on every localized storefront - Plaud Tayler - 2026-08-20 20:05 */
    var labelPlay = btn.getAttribute('data-label-play') || 'Resume auto-advance';
    var labelPause = btn.getAttribute('data-label-pause') || 'Pause auto-advance';
    btn.setAttribute('aria-pressed', paused ? 'true' : 'false');
    btn.setAttribute('aria-label', paused ? labelPlay : labelPause);
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-dotnav-pause]');
    if (!btn) return;
    var host = btn.closest('slide-section');
    var sw = host && host.globalSlide;
    if (!sw || sw.destroyed) return;
    var pausing = btn.getAttribute('aria-pressed') !== 'true';
    host.__wwDotnavUserPaused = pausing;
    if (pausing) sw.autoplay.stop();
    else sw.autoplay.start();
    setPauseState(btn, pausing);
  });
  /* pause/resume control - End - Plaud Tayler - 2026-08-13 10:20 */

  var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function bind(host) {
    if (host.__wwDotnavBound) return;
    var sw = host.globalSlide;
    var pag = host.querySelector('.ww-dotnav--timed');
    if (!sw || sw.destroyed || !pag) return;
    host.__wwDotnavBound = true;
    if (reducedMotion) {
      // auto-advance is motion: kill the clock, dots stay as static clickable pagination;
      // the pause control reflects the stopped state (pressing it = explicit opt back in)
      sw.autoplay.stop();
      host.__wwDotnavUserPaused = true;
      var rmBtn = host.querySelector('[data-dotnav-pause]');
      if (rmBtn) setPauseState(rmBtn, true);
      return;
    }
    sw.on('autoplayTimeLeft', function (s, timeMs, progress) {
      // progress = fraction REMAINING (1 -> 0); the fill shows elapsed share
      pag.style.setProperty('--ww-dot-progress', (1 - progress).toFixed(4));
    });
    sw.on('autoplayStop', function () {
      pag.style.setProperty('--ww-dot-progress', 0);
    });
    io.observe(host);
  }

  function scan() {
    document.querySelectorAll('slide-section').forEach(function (host) {
      if (host.__wwDotnavBound || host.__wwDotnavObs) return;
      if (!host.querySelector('.ww-dotnav--timed')) return;
      if (host.globalSlide) { bind(host); return; }
      // swiper init is lazy (user-interaction gated); the init run stamps swiper-* classes,
      // and by the time the observer microtask fires, host.globalSlide is assigned
      var mo = new MutationObserver(function () {
        if (host.globalSlide) {
          mo.disconnect();
          host.__wwDotnavObs = null;
          bind(host);
        }
      });
      mo.observe(host, { attributes: true, attributeFilter: ['class'] });
      host.__wwDotnavObs = mo;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
})();
